import { z } from 'zod'

import {
  accountFormDefaultValues,
  ZAccountFormValues,
} from '@/features/update-account/@x/sign-up'
import {
  receiptInformationDefaultValues,
  ReceiptInformationValidation,
  ZReceiptInformationFormValues,
} from '@/features/update-receipt-information/@x/sign-up'

export const defaultValues: TSignUpHostConversionForm = {
  hostIntro: '',
  ...accountFormDefaultValues,
  ...receiptInformationDefaultValues,
  recommenderPhoneNumber: '',
}

export const ZSignUpHostConversionForm = ZAccountFormValues.pick({
  accountHolder: true,
})
  .merge(ZReceiptInformationFormValues)
  .extend({
    hostIntro: z.string().min(1, '호스트 소개를 입력해 주세요.'),
    bankName: z.string().trim().min(1, {
      message: '정산 받으실 은행을 선택해 주세요.',
    }),
    bankAccount: z.string().trim().min(1, {
      message: '정산 받으실 계좌번호를 입력해 주세요.',
    }),
    recommenderPhoneNumber: z.string().optional(),
  })
  .superRefine(ReceiptInformationValidation)

export type TSignUpHostConversionForm = z.infer<
  typeof ZSignUpHostConversionForm
>
